/* Removes a Moon Bundles gift line (Basalt-Kugeln) once its paid bundle is no longer in the cart,
   otherwise the gift stays behind at full price. Runs after every cart change and on cart pages. */
(function () {
  var busy = false;
  function mb(item) {
    try { return JSON.parse((item.properties || {}).__moonbundle || 'null'); } catch (e) { return null; }
  }
  function check() {
    if (busy) return;
    busy = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bundles = {}, orphans = {};
        cart.items.forEach(function (it) {
          var m = mb(it);
          if (m && m.type !== 'gift') bundles[m.bundle_id] = true;
        });
        cart.items.forEach(function (it) {
          var m = mb(it);
          if (m && m.type === 'gift' && !bundles[m.bundle_id]) orphans[it.key] = 0;
        });
        if (!Object.keys(orphans).length) { busy = false; return; }
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: orphans })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () { busy = false; });
  }
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(change|update|clear)/.test(url) && !busy) {
      p.then(function () { setTimeout(check, 300); }).catch(function () {});
    }
    return p;
  };
  if (/\/cart(\/|$|\?)/.test(location.pathname)) check();
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('cart-drawer, #CartDrawer')) check();
  });
})();
